if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.pendingRequestUrl = null;
      this.abortController = undefined;
    }

    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    optionValueChangeUnsubscriber = undefined;

    connectedCallback() {
      this.optionValueChangeUnsubscriber = subscribe(
        PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
      );
      this.initQuantityHandlers();
    }

    disconnectedCallback() {
      this.optionValueChangeUnsubscriber?.();
      this.cartUpdateUnsubscriber?.();
      this.variantChangeUnsubscriber?.();
    }

    get sectionId() {
      return this.dataset.originalSection || this.dataset.section;
    }

    initQuantityHandlers() {
      if (!this.input) return;
      this.quantityForm = this.querySelector('.product-form__quantity');
      if (!this.quantityForm) return;
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data.sectionId !== this.sectionId) return;
        this.updateQuantityRules(event.data.sectionId, event.data.html);
        this.setQuantityBoundries();
      });
    }

    normalizePath(url) {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!target) return;

      const picker = target.closest('variant-radios, variant-selects');
      if (!picker || picker.dataset.section !== this.dataset.section) return;

      this.resetProductFormState();

      const productUrl =
        target.dataset.productUrl ||
        target.dataset.combinedListingUrl ||
        this.pendingRequestUrl ||
        this.dataset.url;
      this.pendingRequestUrl = productUrl;
      const shouldSwapProduct = this.normalizePath(productUrl) !== this.normalizePath(this.dataset.url);

      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues),
        targetId: target.id,
        callback: shouldSwapProduct
          ? this.handleSwapProduct(productUrl)
          : this.handleUpdateProductInfo(productUrl),
      });
    }

    resetProductFormState() {
      document
        .querySelectorAll(`#product-form-${this.dataset.section} [name="add"], #product-form-${this.dataset.section}-duplicate [name="add"]`)
        .forEach((button) => button.setAttribute('disabled', 'disabled'));
    }

    buildRequestUrlWithParams(url, optionValues) {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      if (optionValues?.length) fetchUrl.searchParams.set('option_values', optionValues.join(','));
      return fetchUrl.toString();
    }

    renderProductInfo({ requestUrl, targetId, callback }) {
      this.abortController?.abort();
      this.abortController = new AbortController();

      console.warn('....')

      fetch(requestUrl, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((responseText) => {
          this.pendingRequestUrl = null;
          callback(new DOMParser().parseFromString(responseText, 'text/html'));

          function MZPexecuteScripts(container) {
            const scripts = container.querySelectorAll('script');
            scripts.forEach((oldScript) => {
              const newScript = document.createElement('script');
              // copy attributes (src, type, async, etc.)
              for (const attr of oldScript.attributes) {
                newScript.setAttribute(attr.name, attr.value);
              }
              // copy inline code
              newScript.textContent = oldScript.textContent;
              // replace in DOM — this triggers execution
              oldScript.parentNode.replaceChild(newScript, oldScript);
            });
          }          
          var $elm = document.querySelector('.magiczoomplus-custom');
          if ($elm) {
            MZPexecuteScripts($elm);
            
            var $sirvElm = document.querySelector('a[data-slide-id="spin"]')
            if ($sirvElm) {
              if ($sirvElm.classList.contains('active-magic-selector')) {
                _mt_click( document.querySelector('.MagicToolboxSelectorsContainer a:first-child') );
              }
              $sirvElm.parentNode.removeChild($sirvElm);
            }
            
            

            $initmzp_called = false; 
            setTimeout('initmzp();', 500);
            $mjs(document).jAddEvent('domready', function() { MagicZoom.start(); });
          }




        })
        .then(() => {
          if (targetId) document.getElementById(targetId)?.focus();
        })
        .catch((error) => {
          if (error.name === 'AbortError') return;
          console.error(error);
        });
    }

    getSelectedVariant(root = this) {
      const selectedVariant = root.querySelector(
        'variant-radios [data-selected-variant], variant-selects [data-selected-variant]'
      )?.textContent;
      return selectedVariant ? JSON.parse(selectedVariant) : null;
    }

    getMediaGallery() {
      return this.querySelector('media-gallery');
    }

    findMediaGalleryInHtml(html) {
      return html.querySelector(`#ProductInfo-${this.sectionId} media-gallery`)
        || html.querySelector(`#MediaGallery-${this.sectionId}`)
        || html.querySelector('media-gallery');
    }

    handleSwapProduct(productUrl) {
      return (html) => {
        const sectionId = this.sectionId;
        const newProductInfo = html.querySelector(`#ProductInfo-${sectionId}`);
        const variant = this.getSelectedVariant(newProductInfo || html);

        this.updateURL(productUrl, variant?.id);
        this.updateExternalElements(html, sectionId);

        if (newProductInfo) {
          newProductInfo.dataset.url = productUrl;
          this.replaceWith(newProductInfo);
        } else {
          this.updateMedia(html, variant?.featured_media?.id, true);
        }

        this.publishVariantChange(sectionId, html, variant, productUrl);
      };
    }

    handleUpdateProductInfo(productUrl) {
      return (html) => {
        const sectionId = this.sectionId;
        const productInfoSource = html.querySelector(`#ProductInfo-${sectionId}`);
        const variant = this.getSelectedVariant(productInfoSource || html);

        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);
        this.updateOptionValues(html);

        if (!variant) {
          this.setUnavailable();
          return;
        }

        this.updateMedia(html, variant.featured_media?.id);

        this.updateSourceFromDestination(html, 'price');
        this.updateSourceFromDestination(html, 'price-sticky');
        this.updateSourceFromDestination(html, 'Sku', (el) => el.classList.contains('visibility-hidden'));
        this.updateSourceFromDestination(html, 'Inventory', (el) => el.innerText === '');
        this.updateQuantityRules(sectionId, html);
        this.toggleAddButtonFromHtml(html, sectionId);
        this.updateProductBadge(html, sectionId);

        this.publishVariantChange(sectionId, html, variant, productUrl);
      };
    }

    updateExternalElements(html, sectionId) {
      this.replaceFromHtml(html, `#MediaStickyAddToCart-${this.dataset.section}`, `#MediaStickyAddToCart-${sectionId}`);
      this.replaceFromHtml(html, `#ProductModal-${this.dataset.section}`, `#ProductModal-${sectionId}`);
      this.replaceFromHtml(html, `#variant-radios-${this.dataset.section}-duplicate`, `#variant-radios-${sectionId}-duplicate`);
      this.replaceFromHtml(html, `#variant-selects-${this.dataset.section}-duplicate`, `#variant-selects-${sectionId}-duplicate`);
      this.replaceFromHtml(html, `#product-form-${this.dataset.section}-duplicate`, `#product-form-${sectionId}-duplicate`);
      this.replaceFromHtml(html, `#product-form-installment-${this.dataset.section}`, `#product-form-installment-${sectionId}`);
      this.updateProductBadge(html, sectionId);
      this.toggleAddButtonFromHtml(html, sectionId);
    }

    replaceFromHtml(html, currentSelector, updatedSelector) {
      const current = document.querySelector(currentSelector);
      const updated = html.querySelector(updatedSelector);
      if (current && updated) current.replaceWith(updated);
    }

    replaceProductForms(html, sectionId) {
      [
        [`product-form-${this.dataset.section}`, `product-form-${sectionId}`],
        [`product-form-${this.dataset.section}-duplicate`, `product-form-${sectionId}-duplicate`],
        [`product-form-installment-${this.dataset.section}`, `product-form-installment-${sectionId}`],
      ].forEach(([currentId, updatedId]) => {
        const currentForm = document.getElementById(currentId);
        const nextForm = html.getElementById(updatedId);
        if (!currentForm || !nextForm) return;
        const currentProductForm = currentForm.closest('product-form');
        const nextProductForm = nextForm.closest('product-form');
        if (currentProductForm && nextProductForm) currentProductForm.replaceWith(nextProductForm);
        else currentForm.replaceWith(nextForm);
      });
    }

    updateOptionValues(html) {
      const currentPicker = this.querySelector('variant-radios, variant-selects');
      if (!currentPicker) return;
      const updatedPicker = html.querySelector(`#${currentPicker.id}`) || html.querySelector('variant-radios, variant-selects');
      if (updatedPicker) currentPicker.replaceWith(updatedPicker);
    }

    updateSourceFromDestination(html, id, shouldHide = () => false) {
      const source = html.getElementById(`${id}-${this.sectionId}`);
      const destination = document.getElementById(`${id}-${this.dataset.section}`);
      if (!source || !destination) return;
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('visibility-hidden', shouldHide(source));
    }

    updateVariantInputs(variantId) {
      document
        .querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-${this.dataset.section}-duplicate, #product-form-installment-${this.dataset.section}`
        )
        .forEach((form) => {
          const input = form.querySelector('input[name="id"]');
          if (!input) return;
          input.disabled = !variantId;
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateURL(productUrl, variantId) {
      const picker = document.querySelector(
        `variant-radios[data-section="${this.dataset.section}"], variant-selects[data-section="${this.dataset.section}"]`
      );
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      const url = this.buildProductUrl(productUrl, variantId);

      if (shareButton?.updateUrl) shareButton.updateUrl(`${window.shopUrl}${url}`);
      if (picker?.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', url);
    }

    buildProductUrl(productUrl, variantId) {
      const url = new URL(productUrl || this.dataset.url, window.location.origin);
      if (variantId) url.searchParams.set('variant', variantId);
      else url.searchParams.delete('variant');
      return `${url.pathname}${url.search}${url.hash}`;
    }

    updateMedia(html, variantFeaturedMediaId, forceReplace = false) {
      const currentGallery = this.getMediaGallery();
      const updatedGallery = this.findMediaGalleryInHtml(html);
      if (!currentGallery || !updatedGallery) return;

      const currentWrapper = currentGallery.closest('slider-product-component');
      const updatedWrapper = updatedGallery.closest('slider-product-component');

      if (forceReplace || currentWrapper || updatedWrapper) {
        (currentWrapper || currentGallery).replaceWith(updatedWrapper || updatedGallery);
      } else {
        this.syncAllMediaLists(currentGallery, updatedGallery);
      }

      const activeGallery = this.getMediaGallery();
      if (variantFeaturedMediaId && activeGallery?.setActiveMedia) {
        activeGallery.setActiveMedia(`${this.dataset.section}-${variantFeaturedMediaId}`, true, {
          featured_media: { id: variantFeaturedMediaId },
        });
      }

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newModalContent = html.querySelector(`#ProductModal-${this.sectionId} .product-media-modal__content`);
      if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
    }

    syncAllMediaLists(currentGallery, updatedGallery) {
      const sourceLists = currentGallery.querySelectorAll('ul[id^="Slider-"]');
      const destinationLists = updatedGallery.querySelectorAll('ul[id^="Slider-"]');
      sourceLists.forEach((sourceList, index) => {
        const destinationList = destinationLists[index];
        if (destinationList) this.syncMediaList(sourceList, destinationList);
      });
    }

    syncMediaList(sourceList, destinationList) {
      const refreshSourceData = () => {
        const sourceItems = Array.from(sourceList.querySelectorAll('li[data-media-id]'));
        const sourceSet = new Set(sourceItems.map((item) => item.dataset.mediaId));
        const sourceMap = new Map(sourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
        return [sourceItems, sourceSet, sourceMap];
      };

      let [sourceItems, sourceSet, sourceMap] = refreshSourceData();
      const destinationItems = Array.from(destinationList.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(destinationItems.map((item) => item.dataset.mediaId));

      for (let i = destinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(destinationItems[i].dataset.mediaId)) sourceList.prepend(destinationItems[i]);
      }

      sourceItems = Array.from(sourceList.querySelectorAll('li[data-media-id]'));
      sourceItems.forEach((item) => {
        if (!destinationSet.has(item.dataset.mediaId)) item.remove();
      });

      [sourceItems, sourceSet, sourceMap] = refreshSourceData();
      destinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);
        if (sourceData && sourceData.index !== destinationIndex) {
          sourceList.insertBefore(sourceData.item, sourceList.querySelector(`li:nth-of-type(${destinationIndex + 1})`));
          [sourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    toggleAddButtonFromHtml(html, sectionId) {
      const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
      this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
    }

    toggleAddButton(disable = true, text) {
      document
        .querySelectorAll(
          `#product-form-${this.dataset.section} [name="add"], #product-form-${this.dataset.section}-duplicate [name="add"]`
        )
        .forEach((addButton) => {
          const addButtonText = addButton.querySelector('span');
          if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text && addButtonText) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute('disabled');
            if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
          }
        });
    }

    setUnavailable() {
      this.toggleAddButton(true, window.variantStrings.unavailable);
      ['price', 'Inventory', 'Sku'].forEach((id) => {
        document.getElementById(`${id}-${this.dataset.section}`)?.classList.add('visibility-hidden');
      });
    }

    updateProductBadge(html, sectionId) {
      const sourcePrice = html.querySelector(`#price-${sectionId} .price`);
      const priceGallery = document.querySelector(`[id^="PriceProductGallery-${this.dataset.section}"]`);
      if (sourcePrice && priceGallery) priceGallery.className = sourcePrice.className;
    }

    publishVariantChange(sectionId, html, variant, productUrl) {
      publish(PUB_SUB_EVENTS.variantChange, {
        data: { sectionId, html, variant, productUrl },
      });
    }

    setQuantityBoundries() {
      if (!this.input) return;
      const data = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1,
      };

      let min = data.min;
      const max = data.max === null ? data.max : data.max - data.cartQuantity;
      if (max !== null) min = Math.min(min, max);
      if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

      this.input.min = min;
      this.input.max = max;
      this.input.value = min;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }

    getQuantityRulesFetchUrl() {
      const picker = this.querySelector('variant-radios, variant-selects');
      const selectedInput = picker?.querySelector('input:checked');
      const selectedOption = picker?.querySelector('select option:checked');
      const productUrl = selectedInput?.dataset.productUrl || selectedOption?.dataset.productUrl || this.dataset.url;
      const fetchUrl = new URL(productUrl, window.location.origin);
      fetchUrl.searchParams.set('section_id', this.dataset.section);
      if (productUrl === this.dataset.url && this.currentVariant?.value) {
        fetchUrl.searchParams.set('variant', this.currentVariant.value);
      }
      return fetchUrl.toString();
    }

    fetchQuantityRules() {
      if (!this.currentVariant?.value) return;
      this.querySelector('.quantity__rules-cart .loading-overlay')?.classList.remove('hidden');
      fetch(this.getQuantityRulesFetchUrl())
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          this.updateQuantityRules(this.dataset.section, html);
          this.setQuantityBoundries();
        })
        .catch((e) => console.error(e))
        .finally(() => this.querySelector('.quantity__rules-cart .loading-overlay')?.classList.add('hidden'));
    }

    updateQuantityRules(sectionId, html) {
      if (!this.input) return;
      const source = html.getElementById(`ProductInfo-${sectionId}`);
      if (!source) return;

      ['.quantity__input', '.quantity__rules', '.quantity__label'].forEach((selector) => {
        const current = this.querySelector(selector);
        const updated = source.querySelector(selector);
        if (!current || !updated) return;
        if (selector === '.quantity__input') {
          ['data-cart-quantity', 'data-min', 'data-max', 'step'].forEach((attribute) => {
            const value = updated.getAttribute(attribute);
            if (value !== null) current.setAttribute(attribute, value);
          });
        } else {
          current.innerHTML = updated.innerHTML;
        }
      });
    }
  });
}
